export default __webpack_public_path__ + "static/media/tago-screenshot-02.0e93dd69.png";